"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.project.manage': 'Gestisci progetti',
    'knowledge.project.none': 'Nessun progetto',
};
